export default class EstoqueBRF {
  id: number;
  centro: string;
  material: string;
  quantidade: number;
  quantidadeParceiro: number;
  unidadeMedida: string;
  d_E_L_E_T_E: boolean;
  criadoEm: Date;
  excluidoEm: Date;

  constructor(
    id: number,
    centro: string,
    idSku: string,
    quantidade: number,
    quantidadeParceiro: number,
    unidadeMedida: string,
    d_E_L_E_T_E?: boolean,
    criadoEm?: Date,
    excluidoEm?: Date
  ) {
    this.id = id;
    this.centro = centro;
    this.material = idSku;
    this.quantidade = quantidade;
    this.quantidadeParceiro = quantidadeParceiro;
    this.unidadeMedida = unidadeMedida;
    this.d_E_L_E_T_E = d_E_L_E_T_E ?? false;
    this.criadoEm = criadoEm ?? new Date();
    this.excluidoEm = excluidoEm ?? new Date();
  }

  static toJson(estoqueBRF: EstoqueBRF): string {
    return JSON.stringify(estoqueBRF);
  }

  static fromJson(json: object[]): EstoqueBRF[] {
    let estoqueEmbalagens: EstoqueBRF[] = [];
    json.forEach((item: any) => {
      estoqueEmbalagens.push(
        new EstoqueBRF(
          item["Id"],
          item["Centro"],
          item["Material"],
          item["Quantidade"],
          item["QuantidadeParceiro"],
          item["UnidadeMedida"],
          item["D_E_L_E_T_E"],
          item["CriadoEm"],
          item["ExcluidoEm"]
        )
      );
    });
    return estoqueEmbalagens;
  }
}
